import { useFormContext } from "react-hook-form";
import { FormControl, Input, InputLabel } from "@mui/material";
import { VRSTA_OPERATERA } from "../../../../enums";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const nazivPolja = "operaterPlatforme.naziv";

const Index = () => {
  const { register } = useFormContext();
  return (
    <FormControl fullWidth error={!daLiJePoljeValidno(nazivPolja)}>
      <InputLabel htmlFor={nazivPolja}>*Naziv (Name)</InputLabel>
      <Input
        aria-describedby="primarni identifikator naziv"
        {...register(nazivPolja)}
      />
      <PorukaGreskePolja nazivPolja={`${nazivPolja}.naziv`} />
    </FormControl>
  );
};

export default Index;
